<template lang="">
    <div>    
     <v-menu
          ref="menu1"
          v-model="menu1"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="dateFormatted"
              :label="label"
              hint="Formato DD-MM-YYYY"
              persistent-hint
              @blur="date = parseDate(dateFormatted)"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker locale="es"       
          first-day-of-week="1"
        v-model="date" no-title @input="menu1 = false"></v-date-picker>
        </v-menu>
    </div>
</template>
<script>

export default {
    props: {
        label:String 
     },
    
    data: vm => ({
      date: new Date().toISOString().substring(0, 10).replace('T',' '),
      dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
      menu1: false,
      menu2: false
    }),
    computed: {
      computedDateFormatted () {
        return this.formatDate(this.date)
      }
    },

    watch: {
      date (val) {
        this.dateFormatted = this.formatDate(this.date)
      }
    },

    methods: {
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}-${month}-${year}`
      },
      parseDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day.padStart(2, '0')}-${month.padStart(2, '0')}-${year}`
      }
    }
}
</script>
<style lang="">
    
</style>